import { PayloadAction, createSlice } from '@reduxjs/toolkit';

/**
 * Post-sign-in gates that block the app until the user completes a step.
 * Today: the tenant requires two-factor authentication and this user has not
 * enrolled yet (set from /auth/mfa/status on boot and after every sign-in).
 */
interface AuthGateState {
  mfaEnrollmentRequired: boolean;
}

const initialState: AuthGateState = {
  mfaEnrollmentRequired: false,
};

const authGateSlice = createSlice({
  name: 'authGate',
  initialState,
  reducers: {
    setMfaEnrollmentRequired: (state, action: PayloadAction<boolean>) => {
      state.mfaEnrollmentRequired = action.payload;
    },
  },
});

export const { setMfaEnrollmentRequired } = authGateSlice.actions;
export default authGateSlice.reducer;
